<template>
  <div class="p-8 text-surface-500">{{ route.name }} — placeholder</div>
</template>

<script setup lang="ts">
import { useRoute } from 'vue-router'
const route = useRoute()
</script>
